import React from "react";
import Section from "@/components/foundation/Section";
import AppShowcase from "@/components/marketing/AppShowcase";
import GlowOrb from "@/components/foundation/GlowOrb";

export const AppShowcaseSection = () => {
  return (
    <div className="relative overflow-hidden" data-testid="app-showcase-section">
      <GlowOrb
        color="emerald"
        size={640}
        intensity={0.18}
        className="left-1/2 top-40 -translate-x-1/2"
        animate={false}
      />

      <Section
        eyebrow="Inside the App"
        headline="A financial intelligence platform in your pocket."
        subheadline="From your ZenScore to matched funding offers to a secure document vault — every workflow, one tap away."
        align="center"
        spacing="lg"
      >
        <div className="mt-10">
          <AppShowcase />
        </div>
      </Section>
    </div>
  );
};

export default AppShowcaseSection;
